import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { enumValidator, MemberStatus } from '#validation';
export const MemberUpdateStatus = {
    ACTIVE: MemberStatus.ACTIVE,
    DEACTIVATED: MemberStatus.DEACTIVATED,
};
export const memberStatusUpdateSchema = z.object({
    status: enumValidator({
        values: MemberUpdateStatus,
        requiredError: 'member.status.required',
        invalidValueError: 'member.status.invalid',
    }),
});
export class MemberStatusUpdateDto extends createZodDto(memberStatusUpdateSchema) {
}
